import { SettingsAccessibility } from "@mui/icons-material";
import { getAtributo } from "../context/FuncionesContext";
export function agregarPropiedades(objetivo, fuente, keys) {
  for (let key of keys) {
    if (fuente.hasOwnProperty(key)) {
      objetivo[key] = fuente[key];
    }
  }
}

export function eliminarKeys(objeto, keys) {
  for (let key of keys) {
    if (objeto.hasOwnProperty(key)) {
      delete objeto[key];
    }
  }
}

export function fusionarPropiedades(objetivo, fuente, keys) {
  const nuevoObjeto = { ...objetivo };

  for (let key of keys) {
    if (fuente.hasOwnProperty(key)) {
      nuevoObjeto[key] = fuente[key];
    }
  }

  return nuevoObjeto;
}

export function objectToQueryString(obj) {
  return Object.keys(obj)
    .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(obj[key]))
    .join("&");
}

export function updateUrlWithQueryString(obj) {
  const queryString = objectToQueryString(obj);
  const newUrl =
    window.location.protocol +
    "//" +
    window.location.host +
    window.location.pathname +
    "?" +
    queryString;
  window.history.pushState({ path: newUrl }, "", newUrl);
}

const acciones = [
  //"historial_activo",
  "imprimir_activo",
  "excel_activo",
  "email_activo",
  "configuracion_usuario_activo",
  "configuracionesDeListado",
  //"tieneIA",
];

export function fusionarAcciones(opPantalla, opConf) {
  if (!opConf) return opPantalla;
  if (!opPantalla) return opConf;
  if (!opConf && !opPantalla) return {};

  const opConfTieneTitulo = opConf.titulo && opConf.titulo !== "";
  const opPantallaTieneTitulo = opPantalla.titulo && opPantalla.titulo !== "";

  if (opConf.padre === opPantalla.id_a && opConf.orden === 1) {
    if (opConfTieneTitulo) {
      return fusionarPropiedades(opConf, opPantalla, acciones);
    }

    if (!opConfTieneTitulo && opPantallaTieneTitulo) {
      return fusionarPropiedades(opPantalla, opConf, acciones);
    }

    if (!opConfTieneTitulo && !opPantallaTieneTitulo) {
      return fusionarPropiedades(opConf, opPantalla, acciones);
    }
  }
}

export function agregarAcciones(opPantalla, opConf) {
  const opConfTieneTitulo = opConf?.titulo && opConf?.titulo !== "";
  const opPantallaTieneTitulo = opPantalla.titulo && opPantalla.titulo !== "";
  
  if (opConf?.padre === opPantalla.id_a && opConf?.orden === 1) {
    if (opConfTieneTitulo) {
      agregarPropiedades(opConf, opPantalla, acciones);
      return eliminarKeys(opPantalla, acciones);
    }

    if (!opConfTieneTitulo && opPantallaTieneTitulo) {
      agregarPropiedades(opPantalla, opConf, acciones);
      return eliminarKeys(opConf, acciones);
    }

    if (!opConfTieneTitulo && !opPantallaTieneTitulo) {
      agregarPropiedades(opConf, opPantalla, acciones);
      return eliminarKeys(opPantalla, acciones);
    }
  }
}

export function convertirANumero(str) {
  if (/^\d+$/.test(str)) {
    // Verifica si el string contiene solo números
    return Number(str); // Convierte el string en número
  } else {
    return str; // Devuelve el string sin cambios
  }
}

export function esMinuscula(caracter) {
  return caracter === caracter.toLowerCase();
}

export function esNumeroOStringDeNumeros(variable) {
  return !isNaN(variable) && variable !== "" && /^\d+$/.test(variable);
}

export function focusFirstFocusableChild(parentElement) {
  // Si no se pasa un elemento, buscarlo por id
  // console.log(parentElement)
  const parentElementId = parentElement?.id || parentElement;
  if (typeof parentElement === "string") {
    //parentElement = document.getElementById(parentElement);

    parentElement = document.querySelector(`[id*="${parentElement}"]`);
    if (!parentElement) {
     // console.log("Elemento no encontrado con id:", parentElementId);
      return null;
    }
  }

  // Buscar el primer hijo focusable
  for (let child of parentElement.children) {
    if (isFocusable(child)) {
      child.focus(); // Aplica el foco directamente al hijo focusable
      child.scrollIntoView({
        behavior: "smooth", // Para un desplazamiento suave
        block: "center", // Alinea el elemento en el centro de la pantalla
      });
      child.classList.add("focus-highlight");
      if (child.tagName === "SELECT") {
        child.click();
      }
      setTimeout(() => {
        child.classList.remove("focus-highlight");
      }, 1000); // El efecto durará 2 segundos
      return child; // Retorna el elemento al que se le hizo foco
    }

    // Si el hijo tiene hijos, buscar recursivamente en esos hijos
    const focusableChild = focusFirstFocusableChild(child);
    if (focusableChild) {
      return focusableChild; // Si encuentra un hijo focusable, devolverlo
    }
  }

  return null; // Si no se encuentra ningún hijo focusable
}

export function isFocusable(element) {
  // Comprobar si el elemento es un input, textarea, select, button o enlace con href
  if (
    element instanceof HTMLInputElement ||
    element instanceof HTMLTextAreaElement ||
    element instanceof HTMLSelectElement ||
    element instanceof HTMLButtonElement ||
    (element instanceof HTMLAnchorElement && element.hasAttribute("href"))
  ) {
    return true;
  }

  // Comprobar si el elemento tiene un atributo tabindex
  if (element.hasAttribute("tabindex") && element.tabIndex >= 0) {
    return true;
  }

  // Comprobar si el elemento es editable
  if (
    element.hasAttribute("contenteditable") &&
    element.getAttribute("contenteditable") !== "false"
  ) {
    return true;
  }

  return false; // Si no cumple con ninguno de los casos anteriores, no es focusable
}

export async function tryFocusWithRetry(focusIdas, retries = 5, delay = 500) {
  if (!focusIdas) return false;

  const elements = focusIdas
    .split(",")
    .map((id) => id.trim())
    .filter(Boolean);

  if (elements.length === 0) return false;

  const timeoutIds = [];
  let success = false;

  const clearAllTimeouts = () => {
    timeoutIds.forEach((timeoutId) => clearTimeout(timeoutId));
    timeoutIds.length = 0;
  };

  const attemptAll = () => {
    if (success) return true;

    for (const parentElement of elements) {
      const focusableElement = focusFirstFocusableChild(parentElement);
      if (focusableElement) {
        success = true;
        clearAllTimeouts();
        return true;
      }
    }

    return false;
  };

  if (attemptAll()) return true;

  return await new Promise((resolve) => {
    let finished = false;
    const totalRetries = Math.max(0, Number(retries));

    const finish = (result) => {
      if (finished) return;
      finished = true;
      clearAllTimeouts();
      resolve(result);
    };

    if (totalRetries === 0) {
      finish(false);
      return;
    }

    const runRound = (round) => {
      if (finished || success) {
        finish(true);
        return;
      }

      if (attemptAll()) {
        finish(true);
        return;
      }

      if (round === totalRetries) {
        finish(false);
      }
    };

    for (let round = 1; round <= totalRetries; round++) {
      const timeoutId = setTimeout(runRound, round * delay, round);

      timeoutIds.push(timeoutId);
    }
  });
}

export const findFirstConfByTipoId = (sconf, id_tipo) => {
  const find_ = (sconf, id_tipo) => {
    const limit = 500;
    let counter = 0;
    let confFound = null;

    const search = (config) => {
      counter++;
      if (counter > limit) return null;

      if (config.configuraciones) {
        for (const c of config.configuraciones) {
          if (c.opciones.tipo.id === id_tipo) {
            return c;
          }
          const result = search(c);
          if (result) return result;
        }
      }

      if (config.sc_hijos) {
        for (const sc of config.sc_hijos) {
          if (sc.tipo.id === id_tipo) {
            return sc;
          }
          const result = search(sc);
          if (result) return result;
        }
      }

      if (config.cabeceras) {
        for (const cab of config.cabeceras) {
          if (cab.tipo.id === id_tipo) {
            return cab;
          }
          const result = search(cab);
          if (result) return result;
        }
      }

      return null;
    };

    confFound = search(sconf);
    return confFound;
  };

  return find_(sconf, id_tipo);
};

export const findFirstConfByTipoIdA = (sconf, id_a) => {
  const find_ = (sconf, id_a) => {
    const limit = 5000;
    let counter = 0;
    let confFound = null;

    const search = (config) => {
      if (config?.tipo?.id === 23 || config?.opciones?.tipo?.id === 23)
        return null;
      counter++;
      if (counter > limit) return null;

      if (config.configuraciones) {
        for (const c of config.configuraciones) {
          if (c.opciones.id_a === id_a) {
            return c;
          }
          const result = search(c);
          if (result) return result;
        }
      }

      if (config.sc_hijos) {
        for (const sc of config.sc_hijos) {
          if (sc.id_a === id_a) {
            return sc;
          }
          if (sc.opciones?.id_a === id_a) {
            return sc;
          }
          const result = search(sc);
          if (result) return result;
        }
      }

      if (config.cabeceras) {
        for (const cab of config.cabeceras) {
          if (cab.id_a === id_a) {
            return cab;
          }
          const result = search(cab);
          if (result) return result;
        }
      }

      return null;
    };

    confFound = search(sconf);
    return confFound;
  };
  try {
    return find_(sconf, id_a);
  } catch (err) {
    console.log(err);
  }
};

export function construirEnlace(data, cab) {
  let e = getAtributo("enlace", data, cab) || "";
  e = e.replace(/^\/+/, "");
  let id_a = getAtributo("enlace_id_a", data, cab) || "";

  if (id_a && checkID_A(id_a) && (!e || e?.trim() === "")) {
    e = "pantalla/";
  }

  const parametros_valores = getAtributo("enlace_parametros", data, cab)
    ?.toString()
    .split(",");

  const en = getAtributo("enlace_parametros_nombres", data, cab)
    ?.toString()
    .split(",");

  let parametros = "";
  const paramObj = {};
  if (parametros_valores && en && parametros_valores.length === en.length) {
    parametros = "?";
    parametros_valores.forEach((qP, i) => {
      const key = en[i];
      parametros += `${i > 0 ? "&" : ""}${key}=${encodeURIComponent(qP)}`;
      paramObj[key] = qP;
    });
  }

  const externo = getAtributo("enlace_externo", data, cab) === "s";

  const enlace = `${e}${id_a}`;
  const enlace_completo = externo
    ? enlace + parametros
    : `${process.env.PUBLIC_URL}/#/${e}${id_a}${parametros}`;

  return {
    enlace,
    parametros,
    enlace_completo,
    externo,
    id_a,
    params: paramObj,
  };
}

export function getLoginURL() {
  const urlActual = encodeURIComponent(window.location.href);
  const publicUrl = process.env.PUBLIC_URL;
  return `${publicUrl}/#/login?from=${urlActual}`;
}

export function goToLogin() {
  const loginURL = getLoginURL();
  document.body.style.cursor = "default";
  return window.location.replace(loginURL);
}

export function debounce(fn, delay) {
  let timer;
  if (delay === 0) {
    return fn;
  }
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

export function validaFormatoFecha(valor) {
  const regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
  return regex.test(valor);
}

export function validaFormatoHora(valor) {
  const regex = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
  return regex.test(valor);
}

export function checkID_A(string) {
  const regex = new RegExp("(^[A-Z]+(_[A-Z]+)*)$", "g");

  const esID_A = regex.test(string);
  return esID_A;
}

export const parseFechaFormato = (fechaFormato) => {
  const showTimeSelect =
    fechaFormato.includes("h") ||
    fechaFormato.includes("H") ||
    fechaFormato.includes("m");
  const showTimeSelectOnly =
    !fechaFormato.includes("d") &&
    !fechaFormato.includes("M") &&
    !fechaFormato.includes("y");
  let timeFormat = "";
  let timeIntervals = 60;

  // Verificar la presencia de horas, minutos y segundos en el formato
  if (fechaFormato.includes("hh") || fechaFormato.includes("HH")) {
    timeFormat += fechaFormato.includes("hh") ? "hh" : "HH"; // 12 horas o 24 horas
  }

  if (fechaFormato.includes("mm")) {
    timeFormat += timeFormat ? ":mm" : "mm"; // Añadir minutos si es necesario
    timeIntervals = 15;
  }

  if (fechaFormato.includes("ss")) {
    timeFormat += timeFormat ? ":ss" : "ss"; // Añadir segundos si es necesario
  }

  return {
    showTimeSelect,
    showTimeSelectOnly,
    timeFormat,
    dateFormat: fechaFormato,
    timeIntervals,
  };
};

export function extraerTextoPlano(valor) {
  if (valor === null || valor === undefined) {
    return "";
  }

  const texto = typeof valor === "string" ? valor : String(valor);

  if (typeof document !== "undefined") {
    const div = document.createElement("div");
    div.innerHTML = texto;
    return div.textContent?.trim() ?? "";
  }

  return texto.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
}

export async function copiarTextoAlPortapapeles(texto) {
  if (!texto) {
    return false;
  }

  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(texto);
    } else {
      copiarConFallback(texto);
    }

    return true;
  } catch (error) {
    copiarConFallback(texto);
    return true;
  }
}

function copiarConFallback(texto) {
  const textArea = document.createElement("textarea");

  textArea.value = texto;
  textArea.setAttribute("readonly", "");
  textArea.style.position = "fixed";
  textArea.style.opacity = "0";

  document.body.appendChild(textArea);
  textArea.select();
  document.execCommand("copy");
  document.body.removeChild(textArea);
}